$( document ).ready(function() {

  $('.item-level-1.item-has-sub>a').click(function (event) {
    event.preventDefault();
    $('.item-level-1').removeClass('active');
    $(this).parent('.item-level-1').addClass('active');
  });

  $( '.item-level-1>a' ).hover(
    function() {
      event.preventDefault();
      var curE = $(this);
      setTimeout(function(){
        var isHovered = curE.is(":hover");
        if(isHovered || curE.parent('.item-level-1').children('.level-2').is(":hover")){
          $('.item-level-1').removeClass('active');
          curE.parent('.item-level-1').addClass('active');
        }else{
          
        }
      }, 150);
      
    }, function() {
  //     var curE = $(this);
		// setTimeout(function(){
		// 	var isHovered = curE.is(":hover");
		// 	if(isHovered || curE.parent('.item-level-1').children('.level-2').is(":hover")){
              
		// 	}else{
		// 		$('.item-level-1').removeClass('active');
  //               $('.item-2').addClass('active');
		// 	}

		// }, 450);
      
      
    }
  );
  $( '.level-0' ).hover(
    function() {
      $('.item-level-1').removeClass('active');
    $(this).parent().find('.item-2').addClass('active');
      
    }, function() {
      
      
      
    }
  );

  $('.level-0').click(function (event) {
    $('.item-level-1').removeClass('active');
    $(this).parent().find('.item-2').addClass('active');
  });
   
    $('.footer__block--menu p, .footer__block--text p ').click(function(){
      if($(window).width() <767){
        if($(this).parent().hasClass('active')){
          $(this).parent().removeClass('active');
        }else{
          $(this).parent().addClass('active');
        }
      }
    });
});
$(window).on('load', function() {
  
    if($.trim($(".product-info variant-swatch-king").html())==''){
      $('.product-info variant-swatch-king').hide();
    }
  
  if(!$(".collection__facets input[name='filter.p.m.custom.show_on_collection']").is(":checked")){
    if($(".main-search-form").length){
      //$(".collection__facets input[name='filter.p.m.custom.show_on_collection']").trigger("click");
    }
    
  }
  if(!$(".collection__facets input[name='filter.p.m.custom.hide_on_webstore']").is(":checked")){
    //$(".collection__facets input[name='filter.p.m.custom.hide_on_webstore']").trigger("click");
  }
  $('body').addClass('loaded');
   $(".select-option-fake").change(function(e){
    var selected = $(this).val();
    $( "button.single-option-selector" ).each(function( index ) {
      if(selected == $(this).val()){
        $( this ).trigger( "click" );
      }
    });
  });
});